module.exports = __webpack_public_path__ + "img/Simple Green.e933f412.jpg";